import { Button, Card, type CardProps, Flex, Group, Indicator, ThemeIcon, Title } from "@mantine/core";
import { IconEdit, IconReportAnalytics } from "@tabler/icons-react";
import type { Report } from "../../models/reports/report";

type ReportCardProps = CardProps & {
  report: Report;
  onAssess: (report: Report) => void;
};

export function ReportCard({ report, onAssess, ...props }: ReportCardProps) {
  return (
    <Indicator processing position="top-end" color="zli-orange" offset={10} tabIndex={0}>
      <Card w="100%" h="100%" {...props}>
        <Flex align="center" gap="md" direction={{ base: "column", sm: "row" }}>
          <ThemeIcon visibleFrom="md" color="zli-blue" size="xl" variant="subtle">
            <IconReportAnalytics size={40} />
          </ThemeIcon>
          <div>
            <Group>
              <Title ta="left" order={4}>
                {report.title}
              </Title>
            </Group>
          </div>
          <Button variant="subtle" ml={{ md: "auto" }} color="zli-orange" onClick={() => onAssess(report)} rightSection={<IconEdit />}>
            Selbsteinschätzen
          </Button>
        </Flex>
      </Card>
    </Indicator>
  );
}
